module.exports = __webpack_public_path__ + "static/media/nav-prep-form.79cd9816.svg";